import { render } from "./similar.vue?vue&type=template&id=5021dd34"
import script from "./similar.vue?vue&type=script&lang=js"
export * from "./similar.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\websites\\zct_v2_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__